import {FETCH_ACCOUNTS_REQUEST, UPDATE_ACCOUNT_REQUEST, UPDATE_ACCOUNT_PERMISSION_REQUEST, DELETE_ACCOUNT_REQUEST, FETCH_PERMISSIONS_REQUEST} from './constants'

export function fetchAccounts() {
  return {type: FETCH_ACCOUNTS_REQUEST}
}

export function updateAccount(updateAccountState) {
  return {type: UPDATE_ACCOUNT_REQUEST, updateAccountState}
}

export function updateAccountPermission(accountState, updatePermissionState) {
  return {type: UPDATE_ACCOUNT_PERMISSION_REQUEST, accountState, updatePermissionState}
}

export function deleteAccount(deleteAccountState) {
  return {type: DELETE_ACCOUNT_REQUEST, deleteAccountState}
}

export function fetchPermissions(accountIDState) {
  return {type: FETCH_PERMISSIONS_REQUEST, accountIDState}
}



// WEBPACK FOOTER //
// ./src/actions/account.js